import { SectionHeader, Stars } from "../../components/public/ui";

const testimonials = [
  {
    content:
      "I had the pleasure of being one of your students during my preparation for the CELPIP test. Thanks to your expert guidance and comprehensive materials, I was able to achieve the results I needed.",
    name: "Ashe Dravendra",
    initials: "AD",
    avatar: "bg-primary text-on-primary",
  },
  {
    content:
      "The system helped me improve my score by 3 points! The practice tests are incredibly realistic. I loved practicing in my free time and receiving instant feedback.",
    name: "Chewi Jkonyi",
    initials: "CJ",
    avatar: "bg-secondary-container text-on-secondary",
  },
  {
    content:
      "The AI-powered scoring in the writing and speaking sections are exceptional. I highly recommend this program to anyone preparing for the CELPIP test.",
    name: "Ligaya Tala",
    initials: "LT",
    avatar: "bg-tertiary text-on-tertiary",
  },
];

export const Testimonials = () => (
  <section className="w-full py-20 bg-surface-container-low/50">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <SectionHeader
        eyebrow="Candidate Success"
        title="Learning Experiences That Inspire Confidence"
        description="See how candidates achieved their target CLB scores and successfully moved forward with their Canadian journey."
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((t) => (
          <div
            key={t.name}
            className="bg-surface-container-lowest p-8 rounded-2xl shadow-sm flex flex-col justify-between gap-6 hover:shadow-md transition-shadow"
          >
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-1 text-accent-warm">
                <Stars />
              </div>
              <p className="font-body-md text-body-md text-on-surface italic">
                "{t.content}"
              </p>
            </div>
            <div className="flex items-center gap-3.5 pt-4">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-sm ${t.avatar}`}
              >
                {t.initials}
              </div>
              <div>
                <h4 className="font-label-md text-label-md text-on-surface font-bold">
                  {t.name}
                </h4>
                <span className="font-body-sm text-on-surface-variant text-xs">
                  CELPIP Test Taker
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
